import { Component, inject } from '@angular/core';
import { VendorDetailService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VendorDetailCreateDto,
  VendorDetailDto,
  VendorDetailExcelDownloadDto,
  VendorDetailUpdateDto,
} from '../proxy/controlling/dtos/vendor-detail';
import { VENDORDETAIL_CONFIG, VENDORDETAIL_FIELDS } from './vendor-detail.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-vendor-detail',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VendorDetailService, ConfirmationService],
  templateUrl: './vendor-detail.html',
  styleUrl: './vendor-detail.scss',
})
export class VendorDetail extends BaseHierarchicalCrudComponent<
  VendorDetailDto,
  VendorDetailCreateDto,
  VendorDetailUpdateDto,
  VendorDetailExcelDownloadDto
> {
  service = inject(VendorDetailService);
  config = VENDORDETAIL_CONFIG;
  fields = VENDORDETAIL_FIELDS;

  protected prepareUpdateDto(data: any, selected: VendorDetailDto): VendorDetailUpdateDto {
    return {
      vendorId: selected.vendorId,
      country: data.country,
      state: data.state,
      city: data.city,
      street: data.street,
      postCode: data.postCode,
      telephoneNumber: data.telephoneNumber,
      cellphoneNumber: data.cellphoneNumber,
      faxNumber: data.faxNumber,
      email: data.email,
      houseNumber: data.houseNumber,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VendorDetail';
  }
}
